// WithMessagePinData.jsx
import { useMemo } from 'react';
import PropTypes from 'prop-types';

import PinIconResource from '../../img/ic_pin_outline.svg';
import PinnedIconResource from '../../img/ic_pin.svg';

const defaultArray = [];
const defaultFunction = () => null;

export const WithMessagePinData = ({
  messageId = null,
  pinnedItemIds = defaultArray,
  children = defaultFunction,
}) => {
  const isPinned = useMemo(() => {
    return pinnedItemIds.includes(messageId);
  }, [messageId, pinnedItemIds]);
  return children({
    isPinned,
    iconSource: isPinned ? PinnedIconResource : PinIconResource,
  });
};

WithMessagePinData.propTypes = {
  messageId: PropTypes.string,
  pinnedItemIds: PropTypes.array,
  children: PropTypes.func,
};

export default WithMessagePinData;
